import { SectionProps } from 'shared-types'
import {
  CalloutCardWithIconNameProps,
  CalloutCardWithImageProps,
  CalloutCardWithoutMediaProps,
} from '~/components/CalloutCard/CalloutCard.types'

export * from 'shared-types'

export type RequiredNonNullable<TObject> = {
  [Key in keyof TObject]-?: NonNullable<TObject[Key]>
}
export type PickNonNullable<
  TObject,
  Key extends keyof TObject
> = RequiredNonNullable<Pick<TObject, Key>>
export type Nullable<T> = T | null | undefined
export type WithNonNullable<TObject, Key extends keyof TObject> = TObject &
  PickNonNullable<TObject, Key>

type Enumerate<
  N extends number,
  Acc extends number[] = []
> = Acc['length'] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc['length']]>

export type IntRange<F extends number, T extends number> = Exclude<
  Enumerate<T>,
  Enumerate<F>
>

export type SectionWithCalloutCards = SectionProps & {
  cards?: (
    | CalloutCardWithoutMediaProps
    | CalloutCardWithIconNameProps
    | CalloutCardWithImageProps
  )[]
}
